export function handleOfferContractUpload() {
    const offerContractUploadSection = document.querySelector('#fy-offer-contract-upload-section') as HTMLElement;
    if (!offerContractUploadSection) {
        return;
    }

    const actualInputField = offerContractUploadSection.querySelector('#input_1_1') as HTMLInputElement;

    //  Create element for virtual upload field.
    let virtualInputSection = document.createElement('div');
    virtualInputSection.classList.add('virtual-input-section');

    let virtualInputField = document.createElement('div');
    virtualInputField.classList.add('virtual-input-field');
    virtualInputField.innerText = "請上載租約";

    let virtualInputButton = document.createElement('button');
    virtualInputButton.setAttribute('id', 'upload_offer_contract_button');
    virtualInputButton.innerText = "上載";

    virtualInputSection.appendChild(virtualInputField);
    virtualInputSection.appendChild(virtualInputButton);

    // Insert created element into the gravity form.
    const offerContractUploadFormInputContainer = offerContractUploadSection.querySelector('#contract-upload-form-wrapper .ginput_container') as HTMLElement;
    offerContractUploadFormInputContainer.insertBefore(virtualInputSection, offerContractUploadFormInputContainer.firstChild);

    // Add Event Listener
    virtualInputField.addEventListener('click', e => {
        actualInputField.click();
    })

    actualInputField.addEventListener('change', e => {
        let filePath = actualInputField.value;
        let fileName = filePath.replace(/^.*[\\\/]/, '');
        console.log(fileName);
        if (fileName) {
            virtualInputField.innerText = fileName;
        } else {
            virtualInputField.innerText = "請上載租約";
        }
    })

    virtualInputButton.addEventListener('click', e => {
        e.preventDefault();
        actualInputField.click();
    })

    const gFormErrMsg = offerContractUploadSection.querySelector('.gform_validation_errors') as HTMLElement;
    if (gFormErrMsg) {
        gFormErrMsg.style.display = 'none';
    }

    actualInputField.style.display = 'none';
    offerContractUploadSection.classList.remove('hide');
}